import _default from './Statistic';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/views/Statistic/index.js
// module id = 3330
// module chunks = 0